<template>
  <div class="card" style="position: sticky; top: 0">
    <CartIcon class="cartIcon" />
    <article class="card-group-item">
      <header class="card-header">
        <h6 class="title">Categorieën</h6>
      </header>
      <div class="filter-content" v-if="categories.length > 0">
        <div class="list-group list-group-flush">
          <template v-for="category in categories">
            <router-link
              :to="{ name: 'category', params: { id: category.id } }"
              :key="category.id"
              v-if="category.parent === 0 && category.count > 0"
            >
              <span class="list-group-item"
                >{{ category.name }}
                <span class="float-right badge badge-secondary round">{{
                  category.count
                }}</span>
              </span>
            </router-link>
          </template>
        </div>
      </div>
      <div class="filter-content" v-else>
        <div class="list-group list-group-flush">
          <span class="d-block" v-for="i in 10" :key="i">
            <span class="list-group-item">
              <content-placeholders class="w-100">
                <content-placeholders-heading :lines="1" />
              </content-placeholders>
            </span>
          </span>
        </div>
        <!-- list-group .// -->
      </div>
    </article>
    <!-- card-group-item.// -->
  </div>
  <!-- card.// -->
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import CartIcon from "@/components/CartIcon";

const { mapGetters } = createNamespacedHelpers("categories");

export default {
  name: "DefaultSidebar",
  components: {
    CartIcon,
  },
  computed: {
    ...mapGetters({
      categories: "categories",
    }),
  },
};
</script>

<style></style>
